import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import createPersistedState from "vuex-persistedstate";
import { Logger } from "@aws-amplify/core";
//ログレベルを設定。ERROR,WARN,INFO,DEBUG,VERBOSEのいずれかを設定する
const logger = new Logger("leco-log", "DEBUG");

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    logger
  },
  modules: {
    auth
  },
  plugins: [
    createPersistedState({
      key: "LecoApp",
      paths: ["auth.user", "auth.isAuthenticated"],
      storage: window.sessionStorage
    })
  ]
});
